module.exports = __webpack_public_path__ + "img/Jh.0716b649.png";